import { Link, withRouter } from 'react-router-dom';
import React, { Component } from 'react';
import { URLImgFront } from '../../config/URLDB';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.min.css';

class Seccion2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            slidesPerView: 3,
            stateSwiper: false
        };

        this.cardsPersonaNatural = [
            { id: 1, to: '/Productos/Ahorros/1/1', img: 'Ahorros.webp', alt: 'AHORROS PERSONA NATURAL', title: 'AHORROS', cta: 'Entérate de más', idl: 1, idp: 1, },
            { id: 2, to: '/Productos/Credito/1/1', img: 'Credito.webp', alt: 'CREDITO PERSONA NATURAL', title: 'CRÉDITOS', cta: 'Entérate de más', idl: 2, idp: 1, },
            { id: 3, to: '/Convenios', img: 'Convenios.webp', alt: 'CONVENIOS PERSONA NATURAL', title: 'CONVENIOS', cta: 'Quiero ver más', },
            { id: 4, to: '/Infantil_Juvenil', img: 'Infantil.webp', alt: 'INFANTIL JUVENIL', title: 'INFANTIL JUVENIL', cta: 'Quiero ver más', },
            { id: 5, to: '/Seguros', img: 'Seguros.webp', alt: 'SEGUROS PERSONA NATURAL', title: 'SEGUROS', cta: 'Quiero ver más', },
        ];

        this.cardsPersonaJuridica = [
            { id: 1, to: '/Productos/Ahorros/1/0', img: 'AhorroEmpresas.webp', alt: 'AHORROS PERSONA JURIDICA', title: 'AHORROS', cta: 'Entérate de más', idl: 1, idp: 0, },
            { id: 2, to: '/Productos/Credito/1/0', img: 'CreditoEmpresas.webp', alt: 'CREDITO PERSONA JURIDICA', title: 'CRÉDITOS', cta: 'Entérate de más', idl: 2, idp: 0, },
            { id: 3, to: '/Convenios', img: 'ConveniosEmpresas.webp', alt: 'CONVENIOS PERSONA JURIDICA', title: 'CONVENIOS', cta: 'Quiero ver más', },
            { id: 4, to: '/Seguros', img: 'SegurosEmpresas.webp', alt: 'SEGUROS PERSONA JURIDICA', title: 'SEGUROS', cta: 'Quiero ver más', },
        ];
    }

    componentDidMount() {
        if (window.screen.width >= 550 && window.screen.width <= 767) {
            this.setState({
                slidesPerView: 2,
                stateSwiper: true
            })
        } else if (window.screen.width >= 60 && window.screen.width <= 549) {
            this.setState({
                slidesPerView: 1,
                stateSwiper: true
            })
        }else{
            this.setState({
                slidesPerView: 3,
                stateSwiper: true
            })
        }
    }

    changeView = (idl, id) => {
        localStorage.setItem('idtipoprod', idl)
        localStorage.setItem('idtipopers', id)
        var name = '';
        if (idl === 2) { name = 'Credito'; localStorage.setItem('nombLinea', 'Crédito') } else { name = 'Ahorros'; localStorage.setItem('nombLinea', 'Ahorros') }
        if (id === 1) { localStorage.setItem('nombTproduct', 'Natural'); localStorage.setItem('TipoPers', 'Personas') } else { localStorage.setItem('nombTproduct', 'Jurídica'); localStorage.setItem('TipoPers', 'Empresas') }
        this.props.history.push('./Productos/' + name + '/' + idl + '/' + id);
    }

    render() {
        const params = {
            slidesPerView: this.state.slidesPerView,
            spaceBetween: 30,
            freeMode: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                480: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            },
            shouldSwiperUpdate: true
        }
        return (
            <React.Fragment>
                <div className="bg-white">
                    <div className="container">
                        <div className="mt-3 pb-5">
                            <div className="py-3 text-center">
                                <p style={{ fontSize: '30px', fontWeight: 'bold' }}>PERSONAS</p>
                            </div>
                            {this.state.stateSwiper ? (<React.Fragment>
                                <Swiper {...params}>
                                    {this.cardsPersonaNatural.map((card) => (
                                        <Link key={card.id} to={card.to} className="card my-3" onClick={card.idl ? () => this.changeView(card.idl, card.idp) : undefined}>
                                            <div className="card-header px-0 py-0">
                                                <img className="img-fluid w-100" style={{ maxHeight:'200px' }} src={`${URLImgFront}/assets/img-variadas/${card.img}`} alt={card.alt} />
                                            </div>
                                            <div className="card-body text-center py-4">
                                                <p className="font-weight-bold text-dark">{card.title}</p>
                                                <div className="my-4 bg-white w-100 font-weight-bold mx-0" style={{ color: '#95bac1', fontSize: '17px' }} >
                                                    {card.cta}
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </Swiper>
                            </React.Fragment>) : (<React.Fragment></React.Fragment>)}
                        </div>
                        <div className="mt-3 pb-5">
                            <div className="py-3 text-center">
                                <p style={{ fontSize: '30px', fontWeight: 'bold' }}>EMPRESAS</p>
                            </div>
                            {this.state.stateSwiper ? (<React.Fragment>
                                <Swiper {...params}>
                                    {this.cardsPersonaJuridica.map((card) => (
                                        <Link key={card.id} to={card.to} className="card my-3" onClick={card.idl ? () => this.changeView(card.idl, card.idp) : undefined}>
                                            <div className="card-header px-0 py-0">
                                                <img className="img-fluid w-100" style={{ maxHeight: '200px' }} src={`${URLImgFront}/assets/img-variadas/${card.img}`} alt={card.alt} />
                                            </div>
                                            <div className="card-body text-center py-4">
                                                <p className="font-weight-bold text-dark">{card.title}</p>
                                                <div className="my-4 bg-white w-100 font-weight-bold mx-0" style={{ color: '#95bac1', fontSize: '17px' }} >
                                                    {card.cta}
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </Swiper>
                            </React.Fragment>) : (<React.Fragment></React.Fragment>)}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(Seccion2);
